export const getUniqId = () => {
  const url = URL.createObjectURL(new Blob([]))
  const uniqId = url.split('/').slice(-1)[0]
  URL.revokeObjectURL(url)
  return uniqId
}
